

import {
	triggerReflow,
	getRootVar
} from '@ifabnpm/bootstrap/utils.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator    from '@ifabnpm/bootstrap/dom/manipulator.js';
import EventHandler   from '@ifabnpm/bootstrap/dom/event-handler.js';

import Reveal   from '@ifabnpm/bootstrap/component/reveal.js';

// -------
// Private
// -------

const setupSelectDropdown = (element) => {
	const form                = SelectorEngine.parents(element, '.form');
	const dropdownToggle      = SelectorEngine.findOne('[data-bs-toggle="dropdown"]', element);
	const dropdownToggleLabel = SelectorEngine.findOne('.button__label', dropdownToggle);
	const dropdownOptions     = SelectorEngine.find('input[type="checkbox"], input[type="radio"]', element);
	const countOptions        = dropdownOptions.length ?? 0;
	const isAutosubmit        = form[0] && element.dataset.autosubmit !== undefined;
	const isMultipleSelect    = element.dataset.multipleSelect !== undefined;

	let statusChanged = false;

	EventHandler.on(element, 'update.selectDropdown', () => {
		if (dropdownToggleLabel) {
			const countChecked = dropdownOptions.filter(element => element.checked);

			if (countChecked.length > 1) {
				dropdownToggleLabel.dataset.count = `${countChecked.length}/${countOptions}`;
			} else if(countChecked.length === 1) {
				dropdownToggleLabel.dataset.count = `${countChecked[0].dataset.label}`;
			} else {
				delete dropdownToggleLabel.dataset.count;
			}
		}
	});

	for (const option of dropdownOptions) {
		EventHandler.on(option, 'click', (event) => {
			EventHandler.trigger(element, 'update.selectDropdown');

			statusChanged = true;
		});
	}

	// Bootstrap-Dropdown initialisieren.
	new bootstrap.Dropdown(dropdownToggle, {
		autoClose: 'outside'
	});

	// Elternformular nach dem Schließen des Dropdown absenden?
	if (isAutosubmit) {
		dropdownToggle.addEventListener('hide.bs.dropdown', () => {
			if (statusChanged) {
				form[0].dataset.loading = 'true';
			}
		});

		dropdownToggle.addEventListener('hidden.bs.dropdown', () => {
			if (statusChanged) {
				setTimeout(() => {
					HTMLFormElement.prototype.submit.call(form[0]);
					// form[0].submit();
				}, 50);
			}
		});
	}

	EventHandler.trigger(element, 'update.selectDropdown');
};

const jobFilter = async () => {
	const formSelectDropdown = SelectorEngine.find('form.job-filter-form .dropdown.form-select-dropdown');

	if (formSelectDropdown) {
		for (const element of formSelectDropdown) {
			setupSelectDropdown(element);
		}
	}
};

const jobDetail = () => {
	const details = SelectorEngine.find('.job .job-details');

	for (const detail of details) {
		const trigger = SelectorEngine.findOne('.job-details__trigger', detail);
		const content = SelectorEngine.findOne('.job-details__content', detail);

		if (content.dataset.reveal === undefined) {
			content.dataset.reveal = 'hide';

			Manipulator.setAria(trigger, 'pressed', false);
		}

		EventHandler.on(trigger, `click`, (event) => {
			event.preventDefault();

			Reveal.toggle(content).then(element => {
				if (element.dataset.reveal === 'show') {
					Manipulator.setAria(trigger, 'pressed', true);
				} else {
					Manipulator.setAria(trigger, 'pressed', false);
				}
			});
		});
	}
};

// --------
// Let's go
// --------

window.addEventListener('load', async function() {
	await jobFilter();
	await jobDetail();
});
